import React, { FC } from 'react';
// import Link from 'next/link';
import './FleetHero.scss';
// import BlockRendererClient from '@/src/app/(root)/news/[id]/Article/Content/BlockRendererClient';
// import Image, { StaticImageData } from 'next/image';
// import img from '@/public/images/fleet-sales/mobileHero.webp';
import cn from 'classnames';
import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';

const FleetHero = ({ fields }) => {
  const isComingSoon = false;
  return (
    <div className={'container fleet-hero'}>
      <div className={'containerFleet'}>
        <div className={'wrapper'}>
          <Image field={fields.image} alt="Hero background" className={'backgroundImage'} />
          <Image
            field={fields.mobileImage}
            alt="Hero background"
            className={cn('backgroundImage', 'mobileImage')}
          />
          <div className={'containerContent'} data-aos="fade-up">
            <div className={'containerText'}>
              {/* <BlockRendererClient content={fields.text} /> */}
              <h1>
                <RichText field={fields.titleRichText} />
              </h1>
              <p>{fields.desc?.value}</p>
              {/* <p>{fields?.desc}</p> */}
            </div>
            <div className={'containerLink'}>
              <a className={'pcButton'} href={fields?.buttonUrl.value.href}>
                {fields?.buttonText?.value}
              </a>
            </div>
          </div>
        </div>

        <a className={'laptopButton'} href={fields?.buttonUrl.value.href}>
          {fields?.buttonText?.value}
        </a>
      </div>
    </div>
  );
};

export default FleetHero;
